var _Path, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgCuratorAdd = function SvgCuratorAdd(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "curator-add_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#curator-add_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.186 8.003C17.336 5.389 14.887 3.5 12 3.5S6.664 5.389 5.814 8.003a1.148 1.148 0 0 1 1.008.45.924.924 0 0 1 .031 1.047 1.084 1.084 0 0 1-.566.436 1.187 1.187 0 0 1-.388.064h-.895c-.554 0-1.009-.452-.938-1.002C4.572 5.05 7.93 2 12 2s7.428 3.05 7.934 6.998c.07.55-.384 1.002-.938 1.002h-.894a1.224 1.224 0 0 1-.388-.064 1.084 1.084 0 0 1-.566-.436.925.925 0 0 1 .03-1.046 1.148 1.148 0 0 1 1.008-.451ZM16 9a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-1.5 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm4.929 11.41c.352-.166.57-.535.494-.917-.56-2.824-3.893-4.993-7.922-4.993-1.002 0-1.96.134-2.843.379.296.412.524.876.667 1.376A9.24 9.24 0 0 1 12.001 16c1.885 0 3.538.547 4.701 1.367.803.566 1.33 1.226 1.598 1.904-1.83.775-3.982 1.229-6.3 1.229-1.015 0-1.999-.087-2.938-.25a4.52 4.52 0 0 1-1.454 1.227c1.379.34 2.856.523 4.393.523 2.737 0 5.287-.584 7.428-1.59Zm-13.68.09a.725.725 0 0 1-.534-.216A.726.726 0 0 1 5 19.75V18.5H3.75a.725.725 0 0 1-.534-.216A.726.726 0 0 1 3 17.75c0-.213.072-.391.216-.535A.726.726 0 0 1 3.75 17H5v-1.25c0-.213.072-.39.216-.534A.726.726 0 0 1 5.75 15c.213 0 .391.072.535.216a.726.726 0 0 1 .215.534V17h1.25c.212 0 .39.072.534.216a.726.726 0 0 1 .216.534c0 .213-.072.391-.216.535a.726.726 0 0 1-.534.215H6.5v1.25c0 .212-.072.39-.216.534a.726.726 0 0 1-.534.216Z",
    fill: "currentColor"
  }))));
};
export default SvgCuratorAdd;